import { useQuery } from "@apollo/react-hooks";

import { Instructor } from "@hubcapp/types";

import GetPricesForAllocationAndLocationQuery from "../graph-ql/getPricesForAllocationAndLocation.graphql";

type GetPricesForAllocationType = {
  instructorId: string;
  propositionAllocationId?: string;
  postcode?: string;
};

const useGetPricesForAllocationAndLocation = ({
  instructorId,
  propositionAllocationId,
  postcode,
}: GetPricesForAllocationType) =>
  useQuery<{ instructor: Instructor }>(GetPricesForAllocationAndLocationQuery, {
    variables: {
      instructorId,
      propositionAllocationId,
      postcode,
    },
    skip: !propositionAllocationId || !postcode,
  });

export default useGetPricesForAllocationAndLocation;
